/* eslint-disable comma-dangle */
/* eslint-disable semi */
/* eslint-disable quotes */
import Vue from "vue";

import Cookies from "js-cookie";

// kendo ui
import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";

import "normalize.css/normalize.css"; // a modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";
import enLang from "element-ui/lib/locale/lang/ko";

import "@/styles/index.scss"; // global css

import App from "./App.vue";
import store from "./store";
import router from "./router";

import "./icons"; // icon
import "./permission"; // permission control
// import "./utils/error-log"; // error log

import "@/styles/font/fonts.scss";

import * as am5 from "@amcharts/amcharts5";

am5.addLicense('AM5C412151596'); // amcharts 라이센스 등록

// naver map
// import naver from "vue-naver-maps";

// Vue.use(naver, {
//   clientID: "wpi5leimta",
// });

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === "production") {
  const { mockXHR } = require("../mock");
  mockXHR();
}

Vue.use(Element, {
  size: Cookies.get("size") || "medium", // set element-ui default size
  locale: enLang,
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
